import script from "./DashboardBoxesLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardBoxesLoader.vue?vue&type=script&setup=true&lang=js"

import "./DashboardBoxesLoader.vue?vue&type=style&index=0&id=9541893a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9541893a"]])

export default __exports__